import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
type LegalParagraph = {
  heading?: string;
  text: string;
};
type LegalSection = {
  title: string;
  paragraphs: LegalParagraph[];
};
export function DatenschutzPage() {
  const {
    language
  } = useLanguage();
  const isGerman = language === 'de';
  const sections = isGerman ? germanSections : englishSections;
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-452">
      <Navigation data-id="element-453" />
      <main className="pt-24 pb-16" data-id="element-454">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-456">
            {isGerman ? 'Datenschutzerklärung' : 'Privacy Policy'}
          </h1>

          <div className="prose prose-invert max-w-none space-y-8 text-gray-400" data-id="element-457">
            {sections.map(section => <section key={section.title} data-id="element-458">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-459">
                  {section.title}
                </h2>
                {section.paragraphs.map((paragraph, index) => <div key={`${section.title}-${index}`} data-id="element-460">
                    {paragraph.heading && <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-461">
                        {paragraph.heading}
                      </h3>}
                    <p className="leading-relaxed mb-4 whitespace-pre-line" data-id="element-462">
                      {paragraph.text}
                    </p>
                  </div>)}
              </section>)}

            <section data-id="element-463">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-464">
                {isGerman ? 'Hinweis zur verantwortlichen Stelle' : 'Responsible Entity'}
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-465">
                {isGerman ? 'Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:' : 'The data controller responsible for processing personal data on this website is:'}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-466">
                CRM Kraft LLC
                <br data-id="element-467" />
                {isGerman ? 'Vertreten durch: Justus Kraft' : 'Represented by: Justus Kraft'}
                <br data-id="element-468" />
                7901 4th St. N, Ste. 300
                <br data-id="element-469" />
                St. Petersburg, FL 33702
                <br data-id="element-470" />
                United States of America
                <br data-id="element-471" />
                {isGerman ? 'Telefon: +49 157 35999071' : 'Phone: +49 157 35999071'}
                <br data-id="element-472" />
                {isGerman ? 'E-Mail: justus@crm-kraft.de' : 'Email: justus@crm-kraft.de'}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-473">
                {isGerman ? 'Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.' : 'The responsible entity is the natural or legal person who alone or jointly with others determines the purposes and means of processing personal data.'}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-474" />
    </div>;
}
const germanSections: LegalSection[] = [{
  title: '1. Datenschutz auf einen Blick',
  paragraphs: [{
    heading: 'Allgemeine Hinweise',
    text: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie dieser Datenschutzerklärung.'
  }, {
    heading: 'Datenerfassung auf dieser Website',
    text: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.\n\nIhre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich zum Beispiel um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten wie Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs.'
  }, {
    heading: 'Wofür nutzen wir Ihre Daten?',
    text: 'Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.'
  }, {
    heading: 'Welche Rechte haben Sie bezüglich Ihrer Daten?',
    text: 'Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten. Sie haben außerdem ein Recht auf Berichtigung oder Löschung dieser Daten, auf Einschränkung der Verarbeitung sowie ein Beschwerderecht bei der zuständigen Aufsichtsbehörde.'
  }]
}, {
  title: '2. Hosting',
  paragraphs: [{
    heading: 'Webflow',
    text: 'Wir hosten unsere Website bei Webflow, Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA. Wenn Sie unsere Website besuchen, erfasst Webflow verschiedene Logfiles inklusive Ihrer IP-Adressen. Webflow speichert Cookies oder sonstige Wiedererkennungstechnologien, die für Darstellung, Funktionen und Sicherheit der Website erforderlich sind.\n\nDetails entnehmen Sie der Datenschutzerklärung von Webflow: https://webflow.com/legal/eu-privacy-policy\n\nDie Verwendung von Webflow erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Sofern eine Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG. Die Einwilligung ist jederzeit widerrufbar.'
  }]
}, {
  title: '3. Allgemeine Hinweise und Pflichtinformationen',
  paragraphs: [{
    heading: 'Datenschutz',
    text: 'Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.\n\nWir weisen darauf hin, dass die Datenübertragung im Internet, zum Beispiel bei der Kommunikation per E-Mail, Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.'
  }, {
    heading: 'Speicherdauer',
    text: 'Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung widerrufen, werden Ihre Daten gelöscht, sofern keine anderen rechtlich zulässigen Gründe für die Speicherung bestehen.'
  }, {
    heading: 'SSL- bzw. TLS-Verschlüsselung',
    text: 'Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Wenn die Verschlüsselung aktiviert ist, können Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.'
  }]
}, {
  title: '4. Datenerfassung auf dieser Website',
  paragraphs: [{
    heading: 'Cookies',
    text: 'Unsere Internetseiten verwenden Cookies. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung oder dauerhaft auf Ihrem Endgerät gespeichert.'
  }, {
    heading: 'Kontaktformular sowie Anfrage per E-Mail oder Telefon',
    text: 'Wenn Sie uns über ein Kontaktformular, per E-Mail oder telefonisch kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten zum Zwecke der Bearbeitung Ihres Anliegens und für den Fall von Anschlussfragen gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.'
  }]
}, {
  title: '5. Plugins und Tools',
  paragraphs: [{
    heading: 'YouTube',
    text: 'Diese Website bindet Videos der Website YouTube ein. Betreiber der Website ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Weitere Informationen zum Umgang mit Nutzerdaten finden Sie unter: https://policies.google.com/privacy?hl=de'
  }, {
    heading: 'Google Web Fonts',
    text: 'Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in seinen Browsercache, um Texte und Schriftarten korrekt anzuzeigen.'
  }]
}];
const englishSections: LegalSection[] = [{
  title: '1. Privacy at a Glance',
  paragraphs: [{
    heading: 'General Information',
    text: 'The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to identify you personally. Detailed information on data protection can be found in this Privacy Policy.'
  }, {
    heading: 'Data Collection on This Website',
    text: 'Data processing on this website is carried out by the website operator. You can find the operator’s contact details in the “Responsible Entity” section of this Privacy Policy.\n\nSome data is collected when you provide it to us, for example, data entered into a contact form. Other data is collected automatically or with your consent by our IT systems when you visit the website. This is primarily technical data such as your browser, operating system, or the time the page was accessed.'
  }, {
    heading: 'What Do We Use Your Data For?',
    text: 'Some data is collected to ensure the website is provided without errors. Other data may be used to analyze your use of the website.'
  }, {
    heading: 'What Rights Do You Have Regarding Your Data?',
    text: 'You have the right to receive information about the origin, recipients, and purpose of your stored personal data free of charge at any time. You also have the right to request correction or deletion of this data, restriction of processing, and to lodge a complaint with the competent supervisory authority.'
  }]
}, {
  title: '2. Hosting',
  paragraphs: [{
    heading: 'Webflow',
    text: 'We host our website with Webflow, Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA. When you visit our website, Webflow collects various log files, including your IP address. Webflow stores cookies and other recognition technologies that are required for the display, functionality, and security of the website.\n\nFor details, please refer to Webflow’s Privacy Policy: https://webflow.com/legal/eu-privacy-policy\n\nWebflow is used on the basis of our legitimate interest in providing a reliable presentation of our website. Where consent has been requested, processing is carried out solely on the basis of your consent, which can be withdrawn at any time.'
  }]
}, {
  title: '3. General Information and Mandatory Disclosures',
  paragraphs: [{
    heading: 'Data Protection',
    text: 'We take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with applicable data protection legislation and this Privacy Policy.\n\nPlease note that data transmission over the internet, for example when communicating by email, may have security gaps. Complete protection of data against access by third parties is not possible.'
  }, {
    heading: 'Storage Period',
    text: 'Unless a more specific storage period is stated in this Privacy Policy, we retain your personal data until the purpose for processing no longer applies. If you make a legitimate request for deletion or withdraw your consent, your data will be deleted unless we have other legally permissible reasons for retaining it.'
  }, {
    heading: 'SSL/TLS Encryption',
    text: 'This website uses SSL/TLS encryption for security reasons and to protect the transmission of confidential content. When encryption is enabled, data you transmit to us cannot be read by third parties.'
  }]
}, {
  title: '4. Data Collection on This Website',
  paragraphs: [{
    heading: 'Cookies',
    text: 'Our website uses cookies. Cookies are small text files that do not harm your device. They are stored either temporarily for the duration of a session or permanently on your device.'
  }, {
    heading: 'Contact Form and Requests by Email or Phone',
    text: 'If you contact us via a contact form, email, or phone, your request, including all personal data arising from it, will be stored and processed for the purpose of handling your request and in case of follow-up questions. We do not share this data without your consent.'
  }]
}, {
  title: '5. Plugins and Tools',
  paragraphs: [{
    heading: 'YouTube',
    text: 'This website embeds videos from YouTube. The website operator is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland. Further information on the handling of user data can be found at: https://policies.google.com/privacy?hl=en'
  }, {
    heading: 'Google Web Fonts',
    text: 'This website uses web fonts provided by Google for a consistent display of fonts. When you access a page, your browser loads the required web fonts into its browser cache to display text and fonts correctly.'
  }]
}];